import {useEffect, useRef, useState} from 'react';

export const useCountdown = (seconds: number) => {
  const [countdown, setCountdown] = useState(seconds);

  const didMount = useRef(false);

  const interval = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (didMount.current) {
      return;
    }

    interval.current = setInterval(() => {
      setCountdown(prevCountdown => prevCountdown - 1);
    }, 1000);

    didMount.current = true;

    return () => {
      clearInterval(interval.current);
    };
  }, []);

  useEffect(() => {
    if (countdown === 0) {
      clearInterval(interval.current);
    }
  }, [countdown]);

  return countdown;
};

export const useOnCountdownEnd = (callback: () => void, seconds: number) => {
  const countdownToClose = useCountdown(seconds);

  const didRun = useRef(false);

  useEffect(() => {
    if (didRun.current) {
      return;
    }

    if (countdownToClose === 0) {
      callback();
      didRun.current = true;
    }
  }, [callback, countdownToClose]);

  return countdownToClose;
};
